/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './tx-empty-state.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../app/shared/component/tx-empty-state/tx-empty-state.component';
const styles_TxEmptyStateComponent:any[] = [i0.styles];
export const RenderType_TxEmptyStateComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_TxEmptyStateComponent,data:{}});
export function View_TxEmptyStateComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),3,'div',([] as any[]),
      [[8,'className',0]],(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(2,0,(null as any),
          (null as any),0,'i',([] as any[]),[[8,'className',0]],(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n'])),
      (_l()(),i1.ɵted(-1,(null as any),['\n']))],(null as any),(_ck,_v) => {
    var _co:i2.TxEmptyStateComponent = _v.component;
    const currVal_0:any = i1.ɵinlineInterpolate(1,'',_co.classType,'');
    _ck(_v,0,0,currVal_0);
    const currVal_1:any = i1.ɵinlineInterpolate(1,'',_co.icon,'');
    _ck(_v,2,0,currVal_1);
  });
}
export function View_TxEmptyStateComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'tx-empty-state',
      ([] as any[]),(null as any),(null as any),(null as any),View_TxEmptyStateComponent_0,
      RenderType_TxEmptyStateComponent)),i1.ɵdid(1,114688,(null as any),0,i2.TxEmptyStateComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const TxEmptyStateComponentNgFactory:i1.ComponentFactory<i2.TxEmptyStateComponent> = i1.ɵccf('tx-empty-state',
    i2.TxEmptyStateComponent,View_TxEmptyStateComponent_Host_0,{icon:'icon',classType:'classType'},
    {},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvamVua2lucy93b3Jrc3BhY2UvcHJvZHVjdGlvbi1hcmdvcy1mcm9udC9hcmdvcy9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnQvdHgtZW1wdHktc3RhdGUvdHgtZW1wdHktc3RhdGUuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2hvbWUvamVua2lucy93b3Jrc3BhY2UvcHJvZHVjdGlvbi1hcmdvcy1mcm9udC9hcmdvcy9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnQvdHgtZW1wdHktc3RhdGUvdHgtZW1wdHktc3RhdGUuY29tcG9uZW50LnRzIiwibmc6Ly8vaG9tZS9qZW5raW5zL3dvcmtzcGFjZS9wcm9kdWN0aW9uLWFyZ29zLWZyb250L2FyZ29zL3NyYy9hcHAvc2hhcmVkL2NvbXBvbmVudC90eC1lbXB0eS1zdGF0ZS90eC1lbXB0eS1zdGF0ZS5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvamVua2lucy93b3Jrc3BhY2UvcHJvZHVjdGlvbi1hcmdvcy1mcm9udC9hcmdvcy9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnQvdHgtZW1wdHktc3RhdGUvdHgtZW1wdHktc3RhdGUuY29tcG9uZW50LnRzLlR4RW1wdHlTdGF0ZUNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgY2xhc3M9e3tjbGFzc1R5cGV9fT5cbiAgPGkgY2xhc3M9XCJ7e2ljb259fVwiPjwvaT5cbjwvZGl2PlxuIiwiPHR4LWVtcHR5LXN0YXRlPjwvdHgtZW1wdHktc3RhdGU+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7TUFBeUIsNENBQ3ZCO1VBQUE7VUFBQSw4QkFBd0I7TUFDcEI7O0lBRkQ7SUFBTCxXQUFLLFNBQUw7SUFDSztJQUFILFdBQUcsU0FBSDs7OztvQkNERjtNQUFBO3NDQUFBLFVBQUE7TUFBQTtJQUFBOzs7OzsifQ==



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/$$_gendir/app/shared/component/tx-empty-state/tx-empty-state.component.ngfactory.ts